import { render } from "./MultiplayerToggle.vue?vue&type=template&id=c157dd94&scoped=true"
import script from "./MultiplayerToggle.vue?vue&type=script&lang=js"
export * from "./MultiplayerToggle.vue?vue&type=script&lang=js"

import "./MultiplayerToggle.vue?vue&type=style&index=0&id=c157dd94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c157dd94"]])

export default __exports__